import React from "react";
import {
	format,
	parseISO,
	isBefore,
	areIntervalsOverlapping,
} from "date-fns";

const AllDayEventItem = ({ event, compact = false }) => {
	const startDate =
		event.start instanceof Date ? event.start : parseISO(event.start);
	const endDate = event.end instanceof Date ? event.end : parseISO(event.start);
	const now = new Date();

	if (!startDate || !endDate) {
		console.error("Invalid date for event:", event);
		return null;
	}

	const isPast = isBefore(endDate, now);
	const isCurrent = areIntervalsOverlapping(
		{ start: startDate, end: endDate },
		{ start: now, end: now }
	);

	const getEventStyles = () => {
		if (isPast) {
			return "bg-gray-200 border border-gray-300 hover:bg-gray-300 dark:bg-gray-300/10 dark:border-gray-300/20 dark:hover:bg-gray-300/20 group";
		}
		if (isCurrent) {
			return "bg-green-100 border border-green-300 hover:bg-green-200 dark:bg-green-500/10 dark:border-green-500/20 dark:hover:bg-green-500/20 group ring-1 ring-green-500/30";
		}
		return "bg-blue-100 border border-blue-300 hover:bg-blue-200 dark:bg-blue-500/10 dark:border-blue-500/20 dark:hover:bg-blue-500/20 group";
	};

	const getDotStyles = () => {
		if (isPast) return "bg-gray-500 dark:bg-gray-400";
		if (isCurrent) return "bg-green-500";
		return "bg-blue-500";
	};

	const getTextStyles = () => {
		if (isPast) {
			return {
				title: "text-gray-700 dark:text-gray-400",
				time: "text-gray-600 dark:text-gray-500",
			};
		}
		if (isCurrent) {
			return {
				title: "text-gray-900 dark:text-gray-100",
				time: "text-gray-700 dark:text-gray-400",
			};
		}
		return {
			title: "text-gray-900 dark:text-gray-100",
			time: "text-gray-700 dark:text-gray-400",
		};
	};

	const textStyles = getTextStyles();

	return (
		<div
			className={`h-7 mx-3 rounded-lg transition-all duration-200 cursor-pointer ${getEventStyles()}`}
		>
			<div className="px-1.5 py-0.5 flex items-center h-full min-w-0">
				<div className="flex-1 flex items-center space-x-1.5 min-w-0">
					<div
						className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${getDotStyles()}`}
					/>
					<span className={`text-xs font-medium truncate ${textStyles.title}`}>
						{event.title || "Untitled Event"}
					</span>
				</div>
				{!compact && (
					<div
						className={`text-xs whitespace-nowrap ml-1.5 ${textStyles.time}`}
					>
						{format(startDate, "MMM d")}
					</div>
				)}
			</div>
		</div>
	);
};

export default AllDayEventItem;
